










































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import { IShip, ICruise } from "@/@types/cruiseOffers/cruiseList";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import axios from "@/api/AuthAPI/auth-request-api";
import { cruiseOffers as cruises, routeInfo } from "@/config/host.config";
import CruiseListCard from "@/components/card/cruises/cruise-list-card.vue";
import { IRouteCity as ICity } from "@/@types/routeInfo/route-info";

@Component({ components: { CruiseListCard } })
export default class CruiseOffers extends Vue {
  @Provide("backgroundFolder") backgroundFolder = "hotel_info/backgrounds";
  @Provide("imageFolder") imageFolder = "hotel_info/image";
  @Provide("cruiseFolder") cruiseFolder = "cruises/low";

  activeShip = "";
  cruiseList: Array<ICruise> = [];
  shipList: Array<IShip> = [];
  citys: Array<ICity> = [];
  alertName = "";
  spinnerImages = false;
  spinnerCruise = false;

  get getShipCode(): string {
    if (!this.activeShip || !this.shipList.length) return "";
    for (const ship of this.shipList) {
      if (this.activeShip === ship.code)
        return ship.name ? this.$getLocale(ship.name) : ship.code;
    }
    return this.activeShip;
  }

  async getShipList(
    uri: string,
    config: AxiosRequestConfig
  ): Promise<Array<IShip>> {
    return new Promise<Array<IShip>>((res, rej) => {
      axios
        .get(uri, config)
        .then((ships: AxiosResponse) => {
          if (ships.status === 200) res(ships.data);
        })
        .catch((e: AxiosError) => {
          rej(e);
        });
    });
  }

  async createShipList(): Promise<Array<IShip>> {
    return new Promise<Array<IShip>>((res, rej) => {
      const uri = cruises.shipList;
      const config: AxiosRequestConfig = { params: {} };
      this.getShipList(uri, config)
        .then((ships: Array<IShip>) => {
          this.shipList = ships;
          res(ships);
        })
        .catch((e: AxiosError) => {
          rej(e);
        });
    });
  }

  async getCruiseList(): Promise<Array<ICruise>> {
    const uri = cruises.mainAPI;
    const config: AxiosRequestConfig = {
      params: { ship_code: this.activeShip },
    };
    return new Promise<Array<ICruise>>((res, rej) => {
      axios
        .get(uri, config)
        .then((cruises: AxiosResponse) => {
          if (cruises.status === 200) res(cruises.data);
        })
        .catch((e: AxiosError) => {
          rej(e);
        });
    });
  }

  @Watch("activeShip")
  createCruiseList(): void {
    this.getCruiseList()
      .then((cruises: Array<ICruise>) => {
        this.cruiseList = cruises;
      })
      .catch((e: AxiosError) => {
        console.log(e);
      });
  }

  async updateCruise(): Promise<void> {
    this.spinnerCruise = true;
    const uri = cruises.mainAPI;
    try {
      const updateCruises = await this.$axios.put(uri);
      if (updateCruises.status === 200)
        this.createShipList().then((ships: Array<IShip>) => {
          this.activeShip = ships[0].code;
          this.createCruiseList();
          this.alertName = "200";
          this.spinnerCruise = false;

          setTimeout(() => {
            this.alertName = "";
          }, this.$second(3));
        });
    } catch (error) {
      console.log(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async updateImages(): Promise<void> {
    this.spinnerImages = true;
    const uri = cruises.cruiseImages;
    const updateImages = await axios.put(uri);

    if (updateImages.status === 200)
      this.createShipList().then((ships: Array<IShip>) => {
        this.activeShip = ships[0].code;
        this.createCruiseList();
        this.alertName = "200";
        this.spinnerImages = false;

        setTimeout(() => {
          this.alertName = "";
        }, this.$second(3));
      });
  }

  async createCityList(): Promise<void> {
    const uri = routeInfo.citys;
    const params = { "match[deleted][value]": false };

    const res = await this.$axios.get(uri, { params });
    if (res.status === 200) this.citys = res.data;
  }

  mounted(): void {
    this.createShipList().then((ships: Array<IShip>) => {
      this.activeShip = ships[0].code;
      this.createCruiseList();
      this.createCityList();
    });
  }
}
